import { createContext, useContext, useEffect, useState } from "react";
import api, { setCurrency } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const apply = (data) => {
    if (data?.currency) setCurrency(data.currency);
    setUser(data);
  };

  useEffect(() => {
    // Senza token salvato siamo su una pagina pubblica: evitiamo una 401 inutile.
    if (!localStorage.getItem("op_token")) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => apply(data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("op_token", data.access_token);
    const me = await api.get("/auth/me");
    apply(me.data);
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("op_token", data.access_token);
    const me = await api.get("/auth/me");
    apply(me.data);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("op_token");
    setUser(false);
    window.location.replace("/");
  };

  return (
    <AuthContext.Provider value={{ user, setUser: apply, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
